module.exports = __webpack_public_path__ + "img/PrimaryKv_bg.0cf4069f.png";